import { NgForOf, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Select } from 'primeng/select';
import { environment } from '../../../environments/environment';
import { App } from '../../app';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';
import { SelectButton } from 'primeng/selectbutton';
import { EFormMode } from '../../enums/EFormMode';
import { EPaymentMethod } from '../../enums/EPaymentMethod';
import { IQueryFormat } from '../../enums/types';
import { IAddToCart } from '../../interfaces/IAddToCart';
import { IOrders_P, IOrdProductDetailsArr } from '../../interfaces/IOrder';
import { IRazorpayOrderBody, IRazorpayOrderResponse, IRazorSuccessResp } from '../../interfaces/IRazorpay';
import { ITodayOffers, ITodayOffers_P, ITodayOffers_S } from '../../interfaces/ITodayOffers';
import { IAddress, IUser, IUser_P } from '../../interfaces/IUser';
import { AuthService } from '../../service/auth.service';
import { ConstantsService } from '../../service/constants.service';
import { DataProviderService } from '../../service/data-provider.service';
import { EventCenterS } from '../../service/event-center.s';
import { OrdersService } from '../../service/orders.service';
import { PaymentMethodService } from '../../service/payment-method.service';
import { TodayOffersService } from '../../service/today-offers.service';
import { UserService } from '../../service/user.service';
import { NotificationService } from '../../service/notification.service';
import { RadioButton } from 'primeng/radiobutton';
import { UtilsService } from '../../service/utils.service';
import { Tooltip } from 'primeng/tooltip';
import { Drawer } from 'primeng/drawer';
import * as _ from 'lodash';
import { PincodeService }from "../../service/get-pincode-details.service";
import { IPincodes, IPincodes_P, IPincodes_S } from '../../interfaces/IPincodes';

declare let Razorpay: any;
declare let paypal: any;

declare global {
    interface Window {
        Paytm: any;
    }
}

@Component({
    selector: 'app-checkout',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        FormsModule,
        PrimeTemplate,
        SelectButton,
        RadioButton,
        NgForOf,
        NgIf,
        Tooltip,
        Drawer,
        Select,
    ],
    templateUrl: './checkout.html',
    styleUrl: './checkout.scss',
})
export class Checkout implements OnInit {
    loading = { form: false };
    checkoutForm: FormGroup;
    selectedOption: string = EPaymentMethod.RAZORPAY;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    hideShowPaypalButton: boolean = false;
    private buttonsInstance: any | null = null;
    paypalButtonsEl: any;
    selectedAddress = <any>new FormControl<any>(''); // default empty

    @ViewChild('addressFormRef') addressFormRef?: ElementRef;

    @ViewChild('paypalButtons') set paypalButtonsRef(
        el: ElementRef<HTMLDivElement> | undefined,
    ) {
        if (el) this.paypalButtonsEl = el;
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY < 99999;
        this.app.hideTopStrip = window.scrollY < 99999;
    }

    cartList: IAddToCart[] = [];
    indiaStates: any[] = [];
    stateCities: any[] = [];
    subtotal: number = 0;
    discount: number = 0;
    shipping: number = 0;
    caseOnDeliveryCharge: number = 0;
    // totalPayableAmount: number = 0;

    mode: string = EFormMode.ADD;
    showForm: boolean = false;
    addressId: string = '';
    userInfo: IUser = <any>{};

    visibleCoupon: boolean = false;
    todayOffers: ITodayOffers[] = [];
    selectedCouponId: string | null = null;
    appliedCouponId: string | null = null;

    promoCode: string = '';
    cartListMap: { [_id: string]: IAddToCart } = {};

    customOptions = [
        {
            label: 'Razorpay',
            value: EPaymentMethod.RAZORPAY,
            icon: 'assets/images/razorpay-icon.svg',
        },
        // { label: 'Paytm', value: EPaymentMethod.PAYTM, icon: 'assets/images/paytm-icon.svg' },
        {
            label: 'Cash on Delivery',
            value: EPaymentMethod.CASH,
            icon: 'assets/images/cod-icon.svg',
        },
        // { label: 'Paypal', value: EPaymentMethod.PAYPAL, icon: 'assets/images/paypal-icon.svg' },
    ];

    constructor(
        private app: App,
        private fb: FormBuilder,
        private ns: NotificationService,
        private cd: ChangeDetectorRef,
        private authService: AuthService,
        private todayOffersService: TodayOffersService,
        private paymentMethodService: PaymentMethodService,
        private userService: UserService,
        private ordersService: OrdersService,
        private cs: ConstantsService,
        private eventCenterS: EventCenterS,
        public utilsService: UtilsService,
        public dataProviderService: DataProviderService,
        private router: Router,
        private pincodeService: PincodeService,
    ) {
        this.checkoutForm = this.fb.group({
            usr_first_name_str: ['', Validators.required],
            usr_last_name_str: ['', Validators.required],
            usr_mobile_number_num: <any>[
                '',
                [
                    Validators.required,
                    Validators.maxLength(10),
                    Validators.minLength(10),
                ],
            ],
            usr_email_str: <any>[
                '',
                Validators.compose([
                    Validators.required,
                    Validators.pattern(this.emailPattern),
                ]),
            ],

            user_apartment_str: [''],
            user_address_name: [''],
            user_street_str: [''],
            usr_landmark_str: [''],
            usr_district_str: [''],
            usr_city_str: [''],
            usr_state_str: [''],
            usr_pin_code_num: [''],
            usr_message_str: [''],
            // acceptTerms: [false, Validators.requiredTrue],
            // paymentMethod: ['EPaymentMethod.PAYPAL']
        });

        if (!this.authService.gUser?._id) this.router.navigate(['/home']);
    }

    async ngOnInit() {
        this.app.isScrolled = true;
        this.app.hideTopStrip = true;
        await this.loadAddress();
        await this.getOrderSummary();
        this.indiaStates = [];
        this.indiaStates = this.dataProviderService.indiaStates();
        this.cd.detectChanges();
        this.eventCenterS.refreshOrderSummary.subscribe(async (data: any) => {
            if (data && data.type) {
                await this.getOrderSummary();
                if (!_.isEmpty(data.promoCodeObj.tdo_code_str)) {
                    this.selectOrApply(data.promoCodeObj);
                } else {
                    this.removeCoupon();
                }
            }
        });
    }

    async applyCoupon() {
        this.visibleCoupon = true;
        await this.loadTodayOffers();
    }

    getCitiesByState(state: string) {
        this.stateCities = this.dataProviderService.stateWiseCities(state);
    }

    onDrawerShow() {
        document.body.classList.add('drawer-open');
    }

    onDrawerHide() {
        this.visibleCoupon = false;
        this.clearBodyScrollLock();
    }

    clearBodyScrollLock() {
        document.body.classList.remove('p-overflow-hidden');
        document.body.classList.remove('drawer-open');
        document.body.style.removeProperty('overflow');
    }

    async loadTodayOffers() {
        this.loading.form = true;
        this.todayOffers = [];
        let query = <IQueryFormat>{
            find: <ITodayOffers_P>{
                active: true,
            },
            select: <ITodayOffers_S>{
                createdAt: 1,
                tdo_code_str: 1,
                tdo_name_str: 1,
                tdo_description_str: 1,
            },
            sort: <ITodayOffers_S>{ createdAt: -1 },
        };
        this.todayOffers = await this.todayOffersService.query(query);
        this.loading.form = false;
        this.cd.detectChanges();
    }

    selectOrApply(coupon: any) {
        // if already applied, do nothing
        if (this.appliedCouponId === coupon._id) return;

        // reset previous discount before applying new coupon
        this.discount = 0;

        // mark selected (for UI)
        this.selectedCouponId = coupon._id;

        // set promo code
        this.promoCode = coupon.tdo_code_str;
        // auto-apply after model update
        setTimeout(async () => {
            await this.applyCode(coupon);
        }, 10);
        this.cd.detectChanges();
    }

    async loadAddress() {
        this.userInfo = await this.userService.getByIdUser(
            <any>this.authService.gUser._id,
        );
        if (
            this.userInfo.usr_address_arr &&
            this.userInfo.usr_address_arr.length
        ) {
            const activeAddress = <any>(
                this.userInfo.usr_address_arr?.find((addr) => addr.active)
            );
            this.selectedAddress.setValue(activeAddress?.user_address_id);
            await this.selectAddress(activeAddress);
        } else {
            this.showForm = true;
        }
        this.checkoutForm.patchValue(<any>this.userInfo);
    }

    async getOrderSummary() {
        let getAddToCartItem = localStorage.getItem('ADD_TO_CART_DATA');
        if (getAddToCartItem) {
            let getAddToCartData = JSON.parse(getAddToCartItem);
            this.discount = getAddToCartData.discount;
            // this.totalPayableAmount = getAddToCartData.total;
            this.subtotal = getAddToCartData.subtotal;
            this.cartList = getAddToCartData.cartList;
            this.cartListMap = getAddToCartData.cartListMap;
        }
    }

    async selectPaymentMethod() {
        if (this.checkoutForm.get('paymentMethod')?.value === 'PAYPAL') {
            this.hideShowPaypalButton = true;
            this.cd.detectChanges();
            setTimeout(async () => {
                // await this.paypalCheckout();
            }, 500);
        } else this.hideShowPaypalButton = false;

        if (this.selectedOption === EPaymentMethod.CASH) {
            this.caseOnDeliveryCharge = 50;
        } else {
            this.caseOnDeliveryCharge = 0;
        }
    }

    // async onSubmit() {
    //     // For PayPal
    //     if (this.checkoutForm.get("paymentMethod")?.value === "PAYPAL") await this.paypalCheckout();
    // }

    // async paypalCheckout() {
    //     let clientId = "AQWcZW3mZjeQJ8x2hzvtCQ3mcYTsfhE-2qFh7avgMr33xWpJL4P-0mers-A5lWhO4i_DQ7PFMfBcv7aw";
    //     let paypalNs: PayPalNamespace | null = await loadScript({
    //         clientId,
    //         currency: 'USD',     // keep in sync with your server
    //         intent: 'capture',   // matches CAPTURE flow on server
    //         components: 'buttons'
    //     });
    //     if (!paypalNs) return this.ns.showError('PayPal SDK failed to load');
    //     else {
    //         // @ts-ignore
    //         this.buttonsInstance = paypalNs.Buttons({
    //             createOrder: async () => {
    //                 // Call your server to create the order; return the PayPal order id
    //                 let resp = await this.paypalService.createOrder({ amount: this.total });
    //                 if (resp) return resp;
    //             },
    //             onApprove: async (data) => {
    //                 console.log(data);
    //                 // Server-side capture
    //                 setTimeout(async () => {
    //                     let resp = await this.paypalService.checkOrderStatus({ orderId: data.orderID });
    //                     if (resp) this.ns.showSuccess('Order Success.');
    //                     else this.ns.showError('Order Failed.');
    //                 }, 2000);
    //             },
    //             onCancel: () => {
    //                 this.ns.showError('Payment cancelled!');
    //             },
    //             onError: (err) => {
    //                 console.error(err);
    //                 this.ns.showError('Something went wrong with PayPal.');
    //             }
    //         });
    //         await this.buttonsInstance.render(this.paypalButtonsEl.nativeElement);
    //     }
    // }

    async paymentBtnClick() {
        if (!this.userInfo.usr_address_arr?.length)
            return this.ns.showError('Please enter address.');
        if (!this.selectedAddress.value)
            return this.ns.showError('Please select address.');
        const product: IOrdProductDetailsArr[] = [];
        for (let item of this.cartList) {
            product.push({
                ord_product_name_str: item.product_name,
                ord_quantity_num: item.qty,
                ord_product_id: <any>item.productId,
                ord_img_url_str: item.fileUrl,
                ord_color_str: item.atc_color_str,
                ord_model_name_str: item.model_name,
                ord_brand_name_str: item.brand_name,
                ord_price_num: item.price,
            });
        }

        let selectedAddress = <any>(
            this.userInfo.usr_address_arr.find(
                (e) => e.user_address_id === this.selectedAddress.value,
            )
        );

        if (!selectedAddress?.usr_pin_code_num)
            return this.ns.showError('Please select a valid address.');

        let obj: IOrders_P = {
            ord_sub_total_amount_num: this.subtotal,
            ord_discount_num: this.discount,
            ord_shipping_charge_num: this.shippingCharge,
            ord_total_amount_num: this.total,
            ord_user_id: <any>this.authService.gUser._id,
            ord_product_details_arr: product,
            ord_apartment_str: selectedAddress.user_apartment_str,
            ord_street_str: selectedAddress.user_street_str,
            ord_landmark_str: selectedAddress.usr_landmark_str,
            ord_district_str: selectedAddress.usr_district_str,
            ord_city_str: selectedAddress.usr_city_str,
            ord_state_str: selectedAddress.usr_state_str,
            ord_pin_code_num: selectedAddress.usr_pin_code_num,
        };

        if (this.selectedOption === EPaymentMethod.RAZORPAY)
            await this.payUsingRazorPay(obj);
        if (this.selectedOption === EPaymentMethod.PAYTM)
            await this.payUsingPaytm(obj);
        if (this.selectedOption === EPaymentMethod.CASH)
            await this.cashOnDelivery(obj);
        // if (this.selectedOption === EPaymentMethod.PAYPAL) await this.payUsingPaypal(obj);
    }

    async payUsingRazorPay(product: IOrders_P) {
        try {
            this.loading.form = true;
            const createOrderBody: IRazorpayOrderBody = {
                amount: <any>product.ord_total_amount_num * 100,
                currency: 'INR',
                receipt: Math.random().toString().substring(2, 15),
                notes: {
                    userId: <any>this.authService.gUser._id,
                    orderDetails: product,
                },
            };
            const createOrderResponse: IRazorpayOrderResponse =
                await this.paymentMethodService.razorpayCreateOrder(
                    createOrderBody,
                );
            const razorPayOptions = {
                key: environment.RAZOR_PAY_KEY,
                amount: <any>product.ord_total_amount_num * 100,
                currency: 'INR',
                order_id: createOrderResponse.id,
                notes: {
                    address: '',
                },
                prefill: {
                    name: `${this.authService.gUser.usr_first_name_str} ${this.authService.gUser.usr_last_name_str}`,
                    email: this.authService.gUser.usr_email_str,
                    contact: this.authService.gUser.usr_mobile_number_num,
                },
                handler: async (successResponse: IRazorSuccessResp) => {
                    // Come into handler if payment is success else called [ payment.failed ] function of razorpay.
                    if (successResponse && successResponse.razorpay_order_id) {
                        let resp =
                            await this.paymentMethodService.razorpayCheckOrderStatus(
                                successResponse,
                            );
                        if (resp) {
                            // await this.loadAddToCardList();
                            // this.checkOutInfo = false;
                            // this.visibleCart = false;
                            this.eventCenterS.loadAddToCard.next(true);
                            this.ns.showSuccess(this.cs.order.orderSuccess);
                            localStorage.removeItem('ADD_TO_CART_DATA');
                            await this.router.navigate(['/orders']);
                        }
                    }
                },
            };
            const rzp = new Razorpay(razorPayOptions);
            rzp.on('payment.failed', (response: any) => {
                // console.log(response);
                this.ns.showError(response.error);
                this.loading.form = false;
            });
            rzp.open();
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(
                e.error || e,
                'Unable to create order.',
            );
        }
        this.cd.detectChanges();
    }

    async payUsingPaytm(product: IOrders_P) {
        this.loading.form = true;
        const createOrderBody = {
            amount: 10,
            customerId: this.authService.gUser._id,
            email: this.authService.gUser.usr_email_str,
            mobile: this.authService.gUser.usr_mobile_number_num.toString(),
            currency: 'INR',
            receipt: Math.random().toString().substring(2, 15),
            notes: {
                userId: <any>this.authService.gUser._id,
                orderDetails: product,
            },
        };

        let resp =
            await this.paymentMethodService.paytmCreateOrder(createOrderBody);

        const host =
            environment.ENV === 'PROD'
                ? 'https://secure.paytmpayments.com'
                : 'https://securestage.paytmpayments.com';

        await this.loadScript(
            `${host}/merchantpgpui/checkoutjs/merchants/${resp.mid}.js`,
        );

        // 3) Configure & invoke
        const config = {
            root: '',
            flow: 'DEFAULT',
            data: {
                orderId: resp.orderId,
                token: resp.txnToken,
                tokenType: 'TXN_TOKEN',
                amount: resp.amount,
            },
            // handler: {
            //     notifyMerchant: function (eventName: string, data: any) {
            //         console.log('Paytm Event:', eventName, data);
            //     }
            // }
            handler: async (successResponse: any) => {
                if (successResponse && successResponse.orderId) {
                    let resp =
                        await this.paymentMethodService.paytmCheckOrderStatus(
                            successResponse,
                        );
                    if (resp) {
                        // await this.loadAddToCardList();
                        // this.checkOutInfo = false;
                        // this.visibleCart = false;
                        this.eventCenterS.loadAddToCard.next(true);
                        this.ns.showSuccess(this.cs.order.orderSuccess);
                        localStorage.removeItem('ADD_TO_CART_DATA');
                        await this.router.navigate(['/orders']);
                    }
                }
            },
        };

        if (window.Paytm && window.Paytm.CheckoutJS) {
            window.Paytm.CheckoutJS.onLoad(() => {
                window.Paytm.CheckoutJS.init(config)
                    .then(() => {
                        window.Paytm.CheckoutJS.invoke();
                    })
                    .catch((err: any) =>
                        console.error('CheckoutJS init error', err),
                    );
            });
        }
        this.loading.form = false;
    }

    async cashOnDelivery(product: IOrders_P) {
        try {
            this.loading.form = true;
            let resp =
                await this.paymentMethodService.orderCashOnDelivery(product);
            if (resp) {
                this.eventCenterS.loadAddToCard.next(true);
                this.ns.showSuccess(this.cs.order.orderSuccess);
                localStorage.removeItem('ADD_TO_CART_DATA');
                await this.router.navigate(['/orders']);
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to order.');
        }
        this.cd.detectChanges();
    }

    private loadScript(src: string) {
        return new Promise<void>((resolve, reject) => {
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) return resolve();

            const s = document.createElement('script');
            s.type = 'application/javascript';
            s.src = src;
            s.crossOrigin = 'anonymous';
            s.onload = () => resolve();
            s.onerror = () => reject(new Error('Failed to load Paytm script'));
            document.head.appendChild(s);
        });
    }

    // async payUsingPaypal(product: IOrders_P) {
    //     const container = document.getElementById('paypal-button-container');
    //     if (container) container.innerHTML = ''; // Clear previous buttons
    //     try {
    //         this.loading.form = true;
    //         paypal.Buttons({
    //             style: {
    //                 layout: 'vertical',
    //                 color: 'gold',
    //                 shape: 'rect',
    //                 label: 'paypal'
    //             },
    //             createOrder: async () => {
    //                 const orderData = {
    //                     amount: product.ord_total_amount_num,
    //                     currency: 'USD',
    //                     receipt: Math.random().toString().substring(2, 15),
    //                     notes: {
    //                         userId: this.authService.gUser._id,
    //                         orderDetails: product,
    //                     }
    //                 };
    //                 const res = await this.paymentMethodService.paypalCreateOrder(orderData);
    //                 return res.id; // PayPal order ID from backend
    //             },
    //
    //             onApprove: async (data: any, actions: any) => {
    //                 const res = await this.paymentMethodService.paypalCaptureOrder({
    //                     orderId: data.orderID
    //                 });
    //                 if (res) {
    //                     alert('✅ Payment successful!');
    //                     await this.router.navigate(['/orders']);
    //                 }
    //             },
    //
    //             onError: (err: any) => {
    //                 console.error('❌ PayPal error:', err);
    //                 this.showErrorFromResponse(err.error || err, 'Unable to create order.');
    //                 alert('Payment failed. Please try again.');
    //             }
    //
    //         }).render('#paypal-button-container');
    //         this.loading.form = false;
    //     } catch (e: any) {
    //         this.loading.form = false;
    //         this.ns.showErrorFromResponse(e.error || e, 'Unable to create order.');
    //     }
    //     this.cd.detectChanges();
    // }

    addNewAddress() {
        this.mode = EFormMode.ADD;
        this.resetForm();
        this.showForm = true;
        this.scrollToForm();
    }

    async selectAddress(dataItem: IAddress) {
        this.selectedAddress.setValue(dataItem?.user_address_id);
        this.shipping = 0;
        if (this.subtotal < 499) {
            let body = <any>{
                pickupPostcode: dataItem?.usr_pin_code_num?.toString(),
                deliveryPostcode: dataItem?.usr_pin_code_num?.toString(),
                weight: 0.27,
            };
            body.isCaseOnDelivery = this.selectedOption === EPaymentMethod.CASH;
            try {
                this.loading.form = true;
                let resp =
                    await this.ordersService.calculateShippingCharge(body);
                if (resp) this.shipping = resp;
                this.loading.form = false;
            } catch (e: any) {
                this.loading.form = false;
                this.ns.showErrorFromResponse(
                    e.error || e,
                    'Unable to select address.',
                );
            }
        }
        this.cd.detectChanges();
    }

    async updateUser() {
        let formData: IUser_P = this.checkoutForm.getRawValue();
        if (!formData.usr_first_name_str)
            return this.ns.showError('Please enter first name.');
        if (!formData.usr_last_name_str)
            return this.ns.showError('Please enter last name.');
        if (!formData.usr_mobile_number_num)
            return this.ns.showError('Please enter mobile number.');
        if (!formData.usr_email_str)
            return this.ns.showError('Please enter mobile number.');
        if (!formData.user_apartment_str)
            return this.ns.showError(
                'Please enter flat, house no., building, company, apartment.',
            );
        if (!formData.user_street_str)
            return this.ns.showError(
                'Please enter area, street, sector, village.',
            );
        if (!formData.usr_landmark_str)
            return this.ns.showError('Please enter landmark.');
        if (!formData.usr_city_str)
            return this.ns.showError('Please enter city / town.');
        if (!formData.usr_district_str)
            return this.ns.showError('Please enter district.');
        if (!formData.usr_state_str)
            return this.ns.showError('Please enter state.');
        if (!formData.usr_pin_code_num)
            return this.ns.showError('Please enter pin code.');
        try {
            this.loading.form = true;
            if (this.mode === EFormMode.ADD) {
                if (!this.userInfo.usr_address_arr?.length)
                    this.userInfo.usr_address_arr = [];
                this.userInfo.usr_address_arr.forEach((addr) => {
                    addr.active = false;
                });
                this.userInfo.usr_address_arr.push({
                    user_address_id: this.utilsService.generateMongoObjectId(),
                    user_address_name: formData.user_address_name || `Address ${this.userInfo.usr_address_arr.length + 1}`,
                    user_apartment_str: formData.user_apartment_str,
                    user_street_str: formData.user_street_str,
                    usr_landmark_str: formData.usr_landmark_str,
                    usr_district_str: formData.usr_district_str || '',
                    usr_city_str: formData.usr_city_str || '',
                    usr_state_str: formData.usr_state_str,
                    usr_pin_code_num: formData.usr_pin_code_num,
                    usr_message_str: <any>formData.usr_message_str,
                    active: true,
                });
            } else {
                for (let item of this.userInfo.usr_address_arr) {
                    item.active = item.user_address_id === this.addressId;
                    if (item.user_address_id === this.addressId) {
                        item.user_address_name = formData.user_address_name || item.user_address_name;
                        item.user_apartment_str = formData.user_apartment_str;
                        item.user_street_str = formData.user_street_str;
                        item.usr_landmark_str = formData.usr_landmark_str;
                        item.usr_district_str = formData.usr_district_str;
                        item.usr_city_str = formData.usr_city_str;
                        item.usr_state_str = formData.usr_state_str;
                        item.usr_pin_code_num = formData.usr_pin_code_num;
                        item.usr_message_str = <any>formData.usr_message_str;
                    }
                }
            }

            let saveObj = {
                usr_first_name_str: formData.usr_first_name_str,
                usr_last_name_str: formData.usr_last_name_str,
                usr_mobile_number_num: formData.usr_mobile_number_num,
                usr_email_str: formData.usr_email_str,
                usr_address_arr: this.userInfo.usr_address_arr,
            };

            let res = await this.userService.updateUser(
                <any>this.authService.gUser._id,
                saveObj,
                { select: '_id' },
            );
            if (res) {
                this.ns.showSuccess(this.cs.user.editSuccess);
                this.resetForm();
                this.userInfo = await this.userService.getByIdUser(
                    <any>this.authService.gUser._id,
                );
                this.userService.gUser.next({ action: 'REFRESH_G_USER' });
                await this.loadAddress();
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(
                e.error || e,
                'Unable to update user.',
            );
        }
        this.cd.detectChanges();
    }

    resetForm() {
        this.mode = EFormMode.ADD;
        this.showForm = false;
        this.addressId = '';
        this.checkoutForm.get('user_apartment_str')?.setValue('');
        this.checkoutForm.get('user_street_str')?.setValue('');
        this.checkoutForm.get('usr_landmark_str')?.setValue('');
        this.checkoutForm.get('usr_district_str')?.setValue('');
        this.checkoutForm.get('usr_city_str')?.setValue('');
        this.checkoutForm.get('usr_state_str')?.setValue('');
        this.checkoutForm.get('usr_pin_code_num')?.setValue(null);
        this.checkoutForm.get('usr_message_str')?.setValue('');
        this.checkoutForm.get('user_address_name')?.setValue('');
    }

    private scrollToForm() {
        setTimeout(() => {
            this.addressFormRef?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
    }

    editAddress(event: Event, dataItem: IAddress) {
        event.stopPropagation();
        this.showForm = true;
        this.scrollToForm();
        this.mode = EFormMode.EDIT;
        this.addressId = dataItem.user_address_id;
        this.checkoutForm
            .get('user_apartment_str')
            ?.setValue(dataItem.user_apartment_str);
        this.checkoutForm
            .get('user_street_str')
            ?.setValue(dataItem.user_street_str);
        this.checkoutForm
            .get('usr_landmark_str')
            ?.setValue(dataItem.usr_landmark_str);
        this.checkoutForm
            .get('usr_state_str')
            ?.setValue(dataItem.usr_state_str);

        // load cities of state in edit mode
        this.getCitiesByState(dataItem.usr_state_str);

        this.checkoutForm.get('usr_district_str')?.setValue(dataItem.usr_district_str || '');
        this.checkoutForm.get('usr_city_str')?.setValue(dataItem.usr_city_str);
        this.checkoutForm
            .get('usr_pin_code_num')
            ?.setValue(dataItem.usr_pin_code_num);
        this.checkoutForm
            .get('usr_message_str')
            ?.setValue(dataItem.usr_message_str);
        this.checkoutForm.get('user_address_name')?.setValue(dataItem.user_address_name || `Address ${this.userInfo.usr_address_arr.findIndex(addr => addr.user_address_id === dataItem.user_address_id) + 1}` );
    }

    async deleteAddress(event: Event, dataItem: IAddress) {
        event.stopPropagation();
        let index = this.userInfo.usr_address_arr.findIndex(
            (e) => e.user_address_id === dataItem.user_address_id,
        );
        if (index !== -1) this.userInfo.usr_address_arr.splice(index, 1);
        try {
            this.loading.form = true;
            let res = await this.userService.updateUser(
                <any>this.authService.gUser._id,
                { usr_address_arr: this.userInfo.usr_address_arr },
                { select: '_id' },
            );
            if (res) {
                this.ns.showSuccess(this.cs.user.addressRemovePermanent);
                this.userInfo = await this.userService.getByIdUser(
                    <any>this.authService.gUser._id,
                );
                this.resetForm();
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(
                e.error || e,
                'Unable to delete address.',
            );
        }
        this.cd.detectChanges();
    }

    async getPinCode() {
        const pinValue = this.checkoutForm.get('usr_pin_code_num')?.value;
        if (!pinValue || pinValue.toString().length < 6) return;
        try {
            const resp: IPincodes[] = await this.pincodeService.queryPublic({
                find: { pincode: pinValue },
            });

            if (resp && resp.length) {
                const stateName: string = this.getState(resp[0]?.state) || '';
                this.getCitiesByState(stateName);
                const cityName: string = this.getCity(resp[0].district) || '';

                this.checkoutForm.get('usr_state_str')?.setValue(stateName);
                this.checkoutForm.get('usr_district_str')?.setValue(cityName);
                this.checkoutForm.get('usr_city_str')?.setValue(resp[0]?.city);
            }
        } catch (e: any) {
            console.warn('Unable to fetch pincode details', e);
        }
    }

    getState(stateFromDB: string): string {
        return (
            this.dataProviderService.indiaStates().find((state) => {
                return state.name.toLowerCase() === stateFromDB.toLowerCase();
            })?.name || ''
        );
    }

    getCity(cityFromDB: string): string {
        return (
            this.stateCities.find((city) => {
                return city.name.toLowerCase() === cityFromDB.toLowerCase();
            })?.name || ''
        );
    }

    async applyCode(coupon?: any) {
        if (!this.promoCode) return;

        // prevent applying again
        if (this.appliedCouponId) {
            return this.ns.showError(this.cs.applyCode.appliedCode);
        }

        try {
            this.loading.form = true;
            let query = <IQueryFormat>{
                find: <ITodayOffers_P>{
                    active: true,
                    tdo_code_str: this.promoCode,
                },
                select: <ITodayOffers_S>{
                    tdo_code_str: 1,
                    tdo_product_id_arr: 1,
                    tdo_percentage_offers_num: 1,
                },
                limit: 1,
            };
            let res = await this.todayOffersService.query(query);
            if (res && res.length) {
                let isExistProductCode = res[0].tdo_product_id_arr.find(
                    (e: string) => this.cartListMap[e],
                );
                if (isExistProductCode) {
                    this.discount = Math.floor(
                        this.total / res[0]?.tdo_percentage_offers_num,
                    );

                    // ✅ mark coupon as applied
                    this.appliedCouponId = coupon?._id || res[0]?._id || null;

                    this.ns.showSuccess(this.cs.applyCode.success);
                    this.closeCouponDrawer();
                } else {
                    this.ns.showError(this.cs.applyCode.invalidCode);
                }
            } else {
                this.ns.showError(this.cs.applyCode.invalidCode);
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(
                e.error || e,
                'Unable to apply code.',
            );
        }
        this.cd.detectChanges();
    }

    closeCouponDrawer() {
        this.visibleCoupon = false;
        this.clearBodyScrollLock();

        setTimeout(() => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }, 0);
    }

    removeCoupon() {
        this.appliedCouponId = null;
        this.selectedCouponId = null;
        this.promoCode = '';
        this.discount = 0;
    }

    get total() {
        return (
            this.subtotal +
            (this.shipping + this.caseOnDeliveryCharge) -
            this.discount
        );
    }

    get shippingCharge() {
        return this.shipping + this.caseOnDeliveryCharge;
    }
}
